// extracted by mini-css-extract-plugin
export const hero = "H_bP";
export const hero_title = "H_bR";
export const hero_team = "H_ck";
export const hero_item = "H_cl";
export const hero_pic = "H_cm";
export const hero_name = "H_cn";
export const hero_position = "H_cp";